<template>
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Locals</h2>
        </div>

        <div slot="body">
            <top-area :integration="currentIntegration" />

            <state-label :integration="currentIntegration" @close="close()" />

            <div class="px-5 pt-4 pb-4">
                <bottom-area
                    :isIntegrated="currentIntegration.integrationStatus == 1"
                    @disableIntegration="disableIntegration()"
                    @saveIntegration=""
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Modal from '@/tools/modal/Modal'
    import topArea from './popupParts/topArea'
    import stateLabel from './popupParts/stateLabel'
    import bottomArea from './popupParts/bottomArea'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                'getSelectedIntegration'
            ]),
            currentIntegration() {
                return this.getSelectedIntegration;
            },
        },
        methods: {
            ...mapActions([
                'requestIntegrationDeactivationViaEmail',
                'closeModal'
            ]),
            disableIntegration() {
                this.requestIntegrationDeactivationViaEmail(this.currentIntegration).then(response => {
                    this.closeModal();
                })
            },
            close() {
                this.closeModal();
            }
        },
        components: {
            topArea,
            bottomArea,
            Modal,
            stateLabel
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// hugLocalsIntegrate.vue?6edd9390